import { render, staticRenderFns } from "./TemplateCertificate.vue?vue&type=template&id=7c80faf3&"
import script from "./TemplateCertificate.vue?vue&type=script&lang=js&"
export * from "./TemplateCertificate.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCertificate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VProgressLinear,VRow})
